
export default function resolve (key) {
  return endpoints[key];
}

const endpoints = {
  urlAlterarTrocaPermissaoRecurso: '/lote/',
  urlElementosTrocaPermissaoRecurso: '/lote/',
  urlAnexarArquivoGuia: '/lote/',
  consultarArquivosGuiaUrl: '/lote/',
  urlDeletarArquivoGuia: '/lote/',
  urlAlterarAcertoCoparticipacao: '/acerto_coparticipacao/alterar',  
  urlAnexarArquivo: '/acerto_coparticipacao/anexar_arquivo/',
  consultarArquivosUrl: '/acerto_coparticipacao/arquivos/',
  urlCancelarAcertoCopart: '/acerto_coparticipacao/cancelar/',
  urlConsultarProcedimentosCopartCalcIncorreto: '/acerto_coparticipacao/consultar_calc_incorreto/',
  urlConsultarProcedimentosDevolucao: '/acerto_coparticipacao/consultar_devolucao/',
  urlConsultarProcedimentosPagAntecipado: '/acerto_coparticipacao/consultar_pag_antecipado/',
  urlConsultarProcedimentos: '/acerto_coparticipacao/consultar_procedimentos/',
  urlConsultarAcertosCoparticipacao: '/acerto_coparticipacao/consultar/',
  urlDeletarArquivo: '/acerto_coparticipacao/deletar_arquivo/',
  demonstrativosAcertoUrl: '/acerto_coparticipacao/demonstrativos/',
  urlDesfazerCancelamentoAcertoCopart: '/acerto_coparticipacao/desfazer_cancelamento/',
  urlConsultarEstadosAcertoCoparticipacao: '/acerto_coparticipacao/estados',
  urlExcluirAcertoCoparticipacao: '/acerto_coparticipacao/excluir/',
  guiasAcertoUrl: '/acerto_coparticipacao/guias/',
  urlIncluirAcertoCoparticipacao: '/acerto_coparticipacao/incluir',
  urlProcessarAcertoCobrancaIndevida: '/acerto_coparticipacao/processar_cobranca_indevida/',
  urlProcessarAcertoDevolucao: '/acerto_coparticipacao/processar_devolucao/',
  urlProcessarAcertoPagAntecipado: '/acerto_coparticipacao/processar_pag_antecipado/',
  urlConsultarNomesTodosProtocolosAcertoCoparticipacao: '/acerto_coparticipacao/protocolos',
  urlConsultarTiposAcertoCoparticipacao: '/acerto_coparticipacao/tipos',
  urlAlterarAcerto: '/acerto_mensalidade/alterar',
  urlAnalisarAcerto: '/acerto_mensalidade/analisar/',
  urlCancelarAcerto: '/acerto_mensalidade/cancelar/',
  urlConsultarAcertosMensalidade: '/acerto_mensalidade/consultar/',
  urlDesfazerCancelamentoAcerto: '/acerto_mensalidade/desfazer_cancelamento/',
  urlConsultarEstadosAcertoMensalidade: '/acerto_mensalidade/estados',
  urlExcluirAcertos: '/acerto_mensalidade/excluir_em_lote',
  urlExcluirAcerto: '/acerto_mensalidade/excluir/',
  urlIncluirAcerto: '/acerto_mensalidade/incluir',
  urlConsultarOrigensAcertoMensalidade: '/acerto_mensalidade/origens',
  urlProcessarAcerto: '/acerto_mensalidade/processar/',
  urlConsultarNomesTodosProtocolosAcertoMensalidade: '/acerto_mensalidade/protocolos',
  urlAlterarAcertosDiversos: '/acertos_diversos/alterar',
  urlConsultarAcertosDiversos: '/acertos_diversos/consultar/',
  urlExcluirAcertosDiversosEmLote: '/acertos_diversos/excluir_em_lote',
  urlExcluirAcertosDiversos: '/acertos_diversos/excluir/',
  urlIncluirAcertosDiversos: '/acertos_diversos/incluir',
  urlProcessarAcertosDiversos: '/acertos_diversos/processar/',
  urlConsultarNomesTodosProtocolosAcertosDiversos: '/acertos_diversos/protocolos',
  urlAlterarAuxilio: '/auxilio_saude/alterar',
  urlHomologarAuxilio: '/auxilio_saude/homologar/',
  urlDesfazerHomologacaoAuxilio: '/auxilio_saude/desfazer_homologacao/',
  urlConsultarAuxiliosSaude: '/auxilio_saude/consultar/',
  urlConsultarEstadosAuxilioSaude: '/auxilio_saude/estados',
  urlExcluirAuxilios: '/auxilio_saude/excluir_em_lote',
  urlExcluirAuxilio: '/auxilio_saude/excluir/',
  urlIncluirAuxilio: '/auxilio_saude/incluir', 
  urlValorReferenciaAuxilio: '/auxilio_saude/valor_referencia/', 
  urlConsultarAgencias: '/agencia/listar/',
  urlGuiaAnexo: '/anexo',
  urlAlterarDentista: '/assistencia_odonto/alterar_dentista',
  urlAlterarReembolsoOdonto: '/assistencia_odonto/alterar',
  urlConsultarAnosPericia: '/assistencia_odonto/anos_pericia',
  urlConsultarReembolsosOdonto: '/assistencia_odonto/consultar/',
  urlDentistas: '/assistencia_odonto/dentistas/',
  urlExcluirDentista: '/assistencia_odonto/excluir_dentista/',
  urlExcluirReembolsoOdonto: '/assistencia_odonto/excluir/',
  urlIncluirDentista: '/assistencia_odonto/incluir_dentista',
  urlIncluirReembolsoOdonto: '/assistencia_odonto/incluir',
  urlConsultarNomeDentista: '/assistencia_odonto/nome_dentista/',
  urlConsultarNumPericias: '/assistencia_odonto/num_pericias',
  urlAuditarAutomaticamenteGuia: '/auditoria/fatura/guia/auditarAutomaticamente',
  urlAutorizarGuia: '/auditoria/fatura/guia/autorizar',
  urlDesfazerAuditoriaGuia: '/auditoria/fatura/guia/desfazer',
  urlGlosarGuia: '/auditoria/fatura/guia/glosar',
  urlAuditarFaturasEmLote: '/auditoria/faturas/auditar',
  urlAuditarAutomaticamenteFaturasEmLote: '/auditoria/faturas/auditarAutomaticamente',
  urlDesfazerFaturasEmLote: '/auditoria/faturas/desfazer',
  urlDevolverFaturasTstEmLote: '/auditoria/faturas/devolver_tst',
  urlEnviarFaturasCnuEmLote: '/auditoria/faturas/enviar_cnu',
  urlFinalizarAvaliacaoFaturasCNU: '/auditoria/faturas/finalizar_avaliacao_cnu',
  urlFinalizarFaturasEmLote: '/auditoria/faturas/finalizar',
  urlConsultarBancos: '/banco/listar',
  urlBeneficiarioConsultar: '/beneficiario/',
  urlAlterarTitularidade: '/beneficiario/alterar_titularidade/',
  urlConsultarLimitesDataFimDependente: '/beneficiario/consultar_datas_fim_limite_dependente/',
  urlConsultarLimitesDataFimTitular: '/beneficiario/consultar_datas_fim_limite_titular/',
  urlConsultarLimitesDataInicioDependente: '/beneficiario/consultar_datas_inicio_limite_dependente/',
  urlConsultarLimitesDataInicioTitular: '/beneficiario/consultar_datas_inicio_limite_titular/',
  urlConsultarDependencias: '/beneficiario/consultar_dependencias/',
  urlEmailsBeneficiario: '/beneficiario/consultar/email/',
  urlEnderecosBeneficiario: '/beneficiario/consultar/endereco/',
  urlHistoricosBeneficiario: '/beneficiario/consultar/historico/',
  urlRequisitadoHistBeneficiario: '/beneficiario/consultar/requisitado_historico/',
  urlHistoricoSituacaoBeneficiario: '/beneficiario/consultar/historico_situacao/',
  urlRequisitadoBeneficiario: '/beneficiario/consultar/requisitado/',
  urlTelefonesBeneficiario: '/beneficiario/consultar/telefone/',
  urlExcluirDependente: '/beneficiario/excluir_dependente',
  urlExcluirTitular: '/beneficiario/excluir_titular',
  urlBeneficiarioConsultarFluxo: '/beneficiario/fluxo',
  urlBeneficiarioIdade: '/beneficiario/consultar/idade/',
  urlHistoricoAdesaoConsultar: '/beneficiario/historico/adesao/',
  urlIncluirDependente: '/beneficiario/incluir_dependente',
  urlIncluirTitular: '/beneficiario/incluir_titular',
  urlConsultarNomesTodosBeneficiarios: '/beneficiario/nomes',
  urlConsultarNomesTodosBeneficiariosPensionista: '/beneficiario/nomes_mais_pensionistas',
  urlConsultarNomesServidoresSemVinculo: '/beneficiario/nomes_sem_vinculo',
  urlSalvarDataFim: '/beneficiario/salvar_data_fim/',
  urlSalvarDataInicial: '/beneficiario/salvar_data_inicial/',
  urlCalcularCoparticipacaoOdonto: '/calculoCoparticipacao/calcular_odonto/',
  urlCalcularCoparticipacao: '/calculoCoparticipacao/calcular/',
  urlConsultarDemonstrativosNaoPagosOdonto: '/calculoCoparticipacao/consultar_nao_pagos_odonto/',
  urlConsultarDemonstrativosNaoPagos: '/calculoCoparticipacao/consultar_nao_pagos/',
  urlConsultarTodosProcedimentos: '/calculoCoparticipacao/consultar_procedimentos',
  urlConsultarTodosProcedimentosCaixa: '/calculoCoparticipacao/consultar_procedimentos_caixa',
  urlLancarCoparticipacao: '/calculoCoparticipacao/lancar',
  urlConsultarCaraterSolicitacao: '/carater_solicitacao/',
  urlCarenciaConsultar: '/carencia/consultar',
  urlCarenciaConsultarPorCarteira: '/carencia/consultar_por_carteira/',
  urlCarenciaSalvar: '/carencia/salvar',
  urlConsultarCeps: '/cep/',
  urlConsultarEnderecoPorCep: '/cep/endereco/',
  urlConsultarContratos: '/contrato/listar/',
  urlConsultarAnosContratos: '/contrato/listar/anos',
  urlConsultarCreditos: '/credito',
  urlAlterarCredito: '/credito/alterar',
  urlCancelarCredito: '/credito/cancelar',
  urlDesfazerCancelamentoCreditoUrl: '/credito/desfazer_cancelamento',
  urlExcluirCredito: '/credito/excluir',
  urlIncluirCredito: '/credito/incluir',
  urlEstruturaCredito: '/credito/recuperar/estrutura',
  urlValidarCredito: '/credito/validar',
  urlConsultarAnosBase: '/declaracao_de_gastos/ano_base',
  urlConsultarDeclaracaoDeGastos: '/declaracao_de_gastos/consulta_geral/',
  urlGerarArquivoDeclaracaoDeGastosDmed: '/declaracao_de_gastos/gerar_arquivo_dmed/',
  urlGerarArquivoDeclaracaoDeGastos: '/declaracao_de_gastos/gerar_arquivo/',
  urlConsultarGrafico: '/demonstrativo/',
  urlAtualizarDadosPagamento: '/demonstrativo/atualizar_dados_pagamento/',
  urlAlterarDemonstrativo: '/demonstrativo/alterar',
  urlIncluirDemonstrativo: '/demonstrativo/incluir',
  urlExcluirDemonstrativo: '/demonstrativo/excluir/',
  urlDesfazerAtesteDocumentosDemonstrativo: '/demonstrativo/desfazer_ateste/',
  urlCancelarDemonstrativo: '/demonstrativo/cancelar/',
  urlDesfazerCancelamentoDemonstrativo: '/demonstrativo/desfazer_cancelamento/',
  urlTrocarOrigemPagamentoDemonstrativo: '/demonstrativo/trocar_origem_pagamento/',
  urlLiberarDemonstrativoParaPagamento: '/demonstrativo/liberar_para_pagamento/',
  urlImpressaoDemonstrativo: '/demonstrativo/impressao/',
  urlConsultarDemonstrativosPorFiltro: '/demonstrativo/consultar/',
  urlConsultarPrestadoresComDp: '/demonstrativo/consultar/prestadores',
  urlConsultarEstadosDp: '/demonstrativo/consultar/estados',
  urlConsultarDemonstrativos: '/demonstrativo/listar',
  urlConsultarFaturasDp: '/demonstrativo/faturas/',
  urlConsultarFaturasOdontoDp: '/demonstrativo/faturas_odonto/',
  urlConsultarCreditosDebitosManuaisDp: '/demonstrativo/creditosDebitosManuais/',
  urlConsultarArquivosDemonstrativo: '/demonstrativo/consultar_arquivos/',
  urlAnexarArquivoDemonstrativo: '/demonstrativo/anexar_arquivo/',
  urlDeletarArquivoDemonstrativo: '/demonstrativo/deletar_arquivo/',
  urlFaturasCandidatas: '/demonstrativo/listar/faturas_candidatas/',
  urlAlterarPagto: '/divida_serv_desligado_pagto/alterar',
  urlBaixarPagto: '/divida_serv_desligado_pagto/baixar_pagto',
  urlCancelarPagto: '/divida_serv_desligado_pagto/cancelar/',
  urlConsultarPagtosServDesligado: '/divida_serv_desligado_pagto/consultar/',
  urlDesfazerCancelamentoPagto: '/divida_serv_desligado_pagto/desfazer_cancelamento/',
  urlExcluirPagto: '/divida_serv_desligado_pagto/excluir/',
  urlIncluirPagto: '/divida_serv_desligado_pagto/incluir',
  urlConsultarTitularesComDivida: '/divida_serv_desligado_pagto/titulares_com_divida',
  urlConsultarTitulares: '/divida_serv_desligado_pagto/titulares',
  urlAlterarDivida: '/divida_serv_desligado/alterar',
  urlBaixarAutomaticamente: '/divida_serv_desligado/baixar_automaticamente',
  urlCancelarDivida: '/divida_serv_desligado/cancelar/',
  urlCompensarCredito: '/divida_serv_desligado/compensar_credito',
  urlConsultarDividasServDesligado: '/divida_serv_desligado/consultar/',
  urlDesfazerCancelamentoDivida: '/divida_serv_desligado/desfazer_cancelamento/',
  urlConsultarEventosDividaServDesligado: '/divida_serv_desligado/eventos',
  urlExcluirDivida: '/divida_serv_desligado/excluir/',
  urlIncluirDivida: '/divida_serv_desligado/incluir',
  urlConsultarServidoresDesligados: '/divida_serv_desligado/servidores',
  urlConsultarTiposDividaServDesligado: '/divida_serv_desligado/tipos',
  urlValidarDivida: '/divida_serv_desligado/validar',
  urlConsultarDividasEmAberto: '/dividas_em_aberto',
  urlExtratoDividaEmAberto: '/dividas_em_aberto/',
  urlConsultarDividasEmAbertoAsync: '/dividas_em_aberto/async',
  urlConsultarSituacaoServidor: '/dividas_em_aberto/situacao/',
  urlCarregarDividasEmAberto: '/dividas_em_aberto/carregar',
  urlExtratoBeneficiarioConsultar: '/extrato_copart_tiss3/consulta/beneficiario/',
  urlExtratoDataInicioAdesao: '/extrato_copart_tiss3/consulta/dataReferencia/',
  urlExtratoDividaEmAbertoBeneficiario: '/extrato_copart_tiss3/consulta/divida_em_aberto/beneficiario/',
  urlExtratoDividaEmAbertoProcedimento: '/extrato_copart_tiss3/consulta/divida_em_aberto/procedimento/',
  urlConsultarDividaPorCarteira: '/extrato_copart_tiss3/consulta/divida_em_aberto/procedimento/carteira/',
  urlExtratoPrestadorConsultar: '/extrato_copart_tiss3/consulta/prestador/',
  urlExtratoProcedimentoConsultar: '/extrato_copart_tiss3/consulta/procedimento/',
  urlExtratoResumidoConsultar: '/extrato_copart_tiss3/consulta/resumido/',
  getDataUltimoFechamentoFolhaURL: '/extrato_copart_tiss3/consulta/data_fechamento_folha',
  isFolhaFechadaUrl: '/extrato_copart_tiss3/consulta/folhaFechada',
  urlExtratoMensalidadeBeneficiarioConsultar: '/extrato_mens_tiss3/consulta/beneficiario/',
  urlExtratoMensalidadeResumidoConsultar: '/extrato_mens_tiss3/consulta/resumido/',
  urlAlterarFaixaEtaria: '/faixa_etaria/alterar',
  urlConsultarFaixasEtarias: '/faixa_etaria/consultar/',
  urlExcluirFaixaEtaria: '/faixa_etaria/excluir',
  urlIncluirFaixaEtaria: '/faixa_etaria/incluir',
  urlValidarFaixaEtaria: '/faixa_etaria/validar/',
  urlAlterarFaixaRemuneracao: '/faixa_remuneracao/alterar',
  urlConsultarFaixasRemuneracao: '/faixa_remuneracao/consultar/',
  urlConsultarDetalhesFaixasRemuneracao: '/faixa_remuneracao/detalhes/',
  urlExcluirFaixaRemuneracao: '/faixa_remuneracao/excluir',
  urlIncluirFaixaRemuneracao: '/faixa_remuneracao/incluir',
  urlValidarFaixaRemuneracao: '/faixa_remuneracao/validar/',
  urlConsultarMotivosDeGlosa: '/glosa/consultar_motivos',
  urlSalvarMotivoGlosaGuia: '/glosa/guia/adicionar_motivo',
  urlConsultarItens: '/item_tabela/consultar/itens/',
  urlConsultarTabelas: '/item_tabela/consultar/tabela',
  urlConsultarTiposDeItem: '/item_tabela/consultar/tipo',
  urlAlterarLimite: '/limite_cobranca/alterar',
  limitesUrl: '/limite_cobranca/consultar',
  urlConsultarUltimoLimite: '/limite_cobranca/consultar/ultimo_limite',
  urlExcluirLimite: '/limite_cobranca/excluir',
  urlIncluirLimite: '/limite_cobranca/incluir',
  urlConsultarLotesPorEstadoProtocolo: '/lote?status=',
  urlConsultarLote: '/lote',
  urlSalvarDtaRecebimentoProcessoFisicoEmLote: '/lote/',
  urlConsultarGuiasDoLote: '/lote/',
  urlConsultarGuia: '/lote/',
  urlConsultarDetalhesGuia: '/lote/',
  urlConsultarGuiaOriginal: '/lote/',
  urlConsultarGuiasSolicitacao: '/lote/',
  urlConsultarGuiasDuplicadas: '/lote/',
  urlConsultarElementos: '/lote/',
  urlAlterarTipoAtendimentoSpsadt: '/lote/',
  urlAlterarCaraterSolicitacao: '/lote/',
  urlSalvarParecerAuditoria: '/lote/',
  urlSalvarGuiaConferida: '/lote/',
  urlCancelarFaturasEmLote: '/lote/cancelar_lotes/motivo/',
  urlExcluirFaturasEmLote: '/lote/excluir_lotes/cpfCnpj/',
  urlCodigoENumeroFaturas: '/lote/fatura/nomes',
  urlCodigoENumeroLotes: '/lote/lotes/nomes',
  urlCodigoENumeroLotesRecurso: '/lote/lotes_recurso/nomes',
  urlConsultarFaturasPorNumGuiaPrestador: '/lote/numGuiaPrestador',
  urlConsultarLotesPorPrestadorOuCodigoFatura: '/lote/prestador/',
  consultarLotesPrestadorCodigoStatus: '/lote/prestador/',
  urlIncluirLoteRecurso:'/lote_recurso/incluir',
  urlGuiasLoteRecurso: '/lote_recurso/guias_recurso/',
  urlGuiasLoteRecursoGeral: '/lote_recurso/guias_recurso/lote/',
  urlEnviarLoteRecursoFaturamento: '/lote_recurso/envio_faturamento/',
  urlExcluirGuiaRecurso:'/lote/',
  urlDesfazerCancelamentoLote: '/lote/',
  urlLiberarFaturasEmLote: '/lote/status/fatura/analisadas',
  urlNegarAuditoriaEmLote: '/lote/status/fatura/negarAuditoria',
  mensalidadesUrl: '/mensalidade/consultar/',
  urlConsultarSeguro: '/mensalidade/consultar/seguro/',
  urlConsultarVigenciasSeguro: '/mensalidade/consultar/vigencias_seguro',
  urlConsultarUltimaMensalidade: '/mensalidade/consultar/ultima_mensalidade',
  valoresMensalidadeUrl: '/mensalidade/consultar/valores/',
  urlExcluirMensalidade: '/mensalidade/excluir',
  urlIncluirMensalidade: '/mensalidade/incluir',
  urlSalvarValorMensalidade: '/mensalidade/salvar_valor',
  urlConsultarOrgaosExternos: '/orgao_externo/listar',
  urlUpdateParametro: '/parametro_sistema/alterar/codParametro',
  urlParametroConsultarParametro: '/parametro_sistema/consultar',
  urlPensionistaConsultarFluxo: '/pensionista/cadastrado_cancelado/tipo_consulta',
  urlConsultarNomeDentistaReceita: '/pessoa/prestador/',
  urlPrestador: '/prestador_consultar/',
  urlPrestadorDadosBancarios: '/prestador_consultar/dados_bancarios/',
  urlConsultarPrestadorCredenciamento: '/prestador_consultar/credenciamento/codPrestador/',
  urlEnderecosPrestador: '/prestador_consultar/enderecos/codPrestador/',
  urlConsultarEspecialidadesDoPrestador: '/prestador_consultar/especialidades/codPrestador/',
  urlConsultarEspecialidadesNaoVinculadasAoPrestador: '/prestador_consultar/especialidades/naoVinculadas/codPrestador/',  
  urlConsultarNomesTodosPrestadores: '/prestador_consultar/nomes',
  urlConsultarPrestadoresComCnpj: '/prestador_consultar/nomes/com_cnpj',  
  urlConsultarNomesTodosPrestadoresCredenciados: '/prestador_consultar/nomes/credenciados',
  urlPrestadorSemOrgaoExterno: '/prestador_consultar/orgao_externo',
  urlTelefonesPrestador: '/prestador_consultar/telefones/codPrestador/',
  urlGruposPrestadores: '/prestador_grupo/0/descricao/',
  urlAlterarGrupo: '/prestador_grupo/alterar',
  urlPrestadoresVinculados: '/prestador_grupo/consultar_prestadores/',
  urlDesvincularPrestadoresEmLote: '/prestador_grupo/desvincular_prestadores',
  urlExcluirGrupo: '/prestador_grupo/excluir/emLote',
  urlIncluirGrupo: '/prestador_grupo/incluir',
  urlConsultarNomesTodosGrupos: '/prestador_grupo/nomes',
  urlConsultarNomesGruposPorTipo: '/prestador_grupo/nomes/',
  urlPrestadoresDesvinculados: '/prestador_grupo/prestadores_desvinculados/',
  urlVincularPrestadoresEmLote: '/prestador_grupo/vincular_prestadores',
  urlAlterarPrestador: '/prestador/alterar',
  urlAlterarCredenciamento: '/prestador/credenciamento/alterar',
  urlExcluirCredenciamentos: '/prestador/credenciamento/excluir',
  urlIncluirCredenciamento: '/prestador/credenciamento/incluir',
  urlValidarCredenciamento: '/prestador/credenciamento/validar/',
  urlAlterarEndereco: '/prestador/endereco/alterar',
  urlExcluirEnderecos: '/prestador/endereco/excluir',
  urlIncluirEndereco: '/prestador/endereco/incluir',
  urlDesincularEspecialidades: '/prestador/especialidade/desvincular/',
  urlVincularEspecialidades: '/prestador/especialidade/vincular/',
  urlExcluirPrestadores: '/prestador/excluir',
  urlIncluirPrestador: '/prestador/incluir',
  urlIncluirPrestadorOrgaoExterno: '/prestador/incluir_orgao_externo',
  salvarDataFimPrestadorUrl: '/prestador/salvar_data_final/',
  salvarDataInicialPrestadorUrl: '/prestador/salvar_data_inicial/',
  urlAlterarTelefone: '/prestador/telefone/alterar',
  urlExcluirTelefones: '/prestador/telefone/excluir',
  urlIncluirTelefone: '/prestador/telefone/incluir',
  urlValidarPrestador: '/prestador/validar/',
  urlVincularPrestadorOrgaoExterno: '/prestador/vincular_orgao_externo/',
  urlConsultarProcessos: '/processo/listar/',
  urlConsultarAnosProcessos: '/processo/listar/anos',
  urlProdutividadeElementosPorMes: '/produtividade_auditoria/mensal/elemento',
  urlProdutividadeFaturasPorMes: '/produtividade_auditoria/mensal/fatura',
  urlProdutividadeGuiasPorMes: '/produtividade_auditoria/mensal/guia',
  urlAlterarProfissional: '/profissional/alterar',
  urlConsultarCROs: '/profissional/CROs',
  urlConsultarEspecialidades: '/profissional/especialidades',
  urlConsultarEspecialidadesPermitidas: '/profissional/especialidadesPermitidas/',
  urlExcluirProfissional: '/profissional/excluir',
  urlIncluirProfissional: '/profissional/incluir',
  urlConsultarNomesTodosProfissionais: '/profissional/nomes',
  urlConsultarProfissionais: '/profissional/profissionais/',
  urlValidarProfissional: '/profissional/validar',
  urlConsultarProtocolo: '/protocolo/consultar/',
  urlListarProtocolos: '/protocolo/listar/numProtocolo/',
  urlBairrosPrestadoresConsultar: '/publico/prestador/bairros',
  urlEspecialidadesPrestadoresConsultar: '/publico/prestador/especialidades',
  urlNomesPrestadoresConsultar: '/publico/prestador/nomes',
  urlConsultarTiposAtendimento: '/publico/tipoAtendimento',
  urlBeneficiarioInternado: '/publico/tipoAtendimento/consultar_internacao/carteira/',
  urlAlterarReembolso: '/reembolso_medico/alterar',
  urlConsultarReembolsos: '/reembolso_medico/consultar/',
  urlExcluirReembolso: '/reembolso_medico/excluir/',
  urlIncluirReembolso: '/reembolso_medico/incluir',
  urlConsultarReembolsosPrestador: '/reembolso_medico/nome_prestador/',
  urlBeneficiariosConsultaGeral: '/relatorio_beneficiarios/consulta_geral',
  urlConsultarRelatorioReembolso: '/relatorio_reembolso/consulta_geral/',
  urlConsultarCovidAutorizacao: '/relatorio/calculo_atuarial/covid_autorizacao/',
  urlConsultarCovidFaturamento: '/relatorio/calculo_atuarial/covid_faturamento/',
  urlConsultarAtuarialDespesas: '/relatorio/calculo_atuarial/despesas/',
  urlConsultarAtuarialCarga: '/relatorio/calculo_atuarial/carga',
  urlConsultarCalculoPrestadores: '/relatorio/calculo_atuarial/prestadores/',
  urlConsultarCalculoReceitasCopartTitular: '/relatorio/calculo_atuarial/receitas_copart_titular/',
  urlConsultarCalculoReceitasCopartDep: '/relatorio/calculo_atuarial/receitas_copart_dep/',
  urlConsultarCalculoReceitasCopartPens: '/relatorio/calculo_atuarial/receitas_copart_pens/',
  urlConsultarCalculoReceitasMensTitular: '/relatorio/calculo_atuarial/receitas_mens_titular/',
  urlConsultarCalculoReceitasMensDep: '/relatorio/calculo_atuarial/receitas_mens_dep/',
  urlConsultarCalculoReceitasAcertoTitular: '/relatorio/calculo_atuarial/receitas_acerto_titular/',
  urlConsultarCalculoReceitasAcertoDep: '/relatorio/calculo_atuarial/receitas_acerto_dep/',
  urlConsultarCalculoReembolsos: '/relatorio/calculo_atuarial/reembolsos/',
  urlConsultarCalculoUsuarios: '/relatorio/calculo_atuarial/usuarios/',
  urlExtratoCoparticipacaoCompletoConsultar: '/relatorio/coparticipacao/completo',
  urlExtratoDividaCompletoConsultar: '/relatorio/dividas_detalhado/completo',
  urlExtratoMensalidadeCompletoConsultar: '/relatorio/mensalidade/completo',
  urlTiposDeTelefone: '/telefone/tipos',
  urlAlterarTipoMensalidade: '/tipo_mensalidade/alterar',
  urlConsultarTiposMensalidade: '/tipo_mensalidade/consultar/',
  urlExcluirTipoMensalidade: '/tipo_mensalidade/excluir',
  urlIncluirTipoMensalidade: '/tipo_mensalidade/incluir',
  urlConsultarTiposSituacaoServidor: '/tipo_situacao',
  urlConsultarUfs: '/UF/nomes',
  urlAbrirXml: '/validacao/previa/abrir/xml/',
  urlAuditarArquivo: '/validacao/previa/auditar',
  urlConsultarParametrosEnvio: '/validacao/previa/consultar',
  enviarArquivoUrl: '/validacao/previa/interno',
  urlValidarArquivo: '/validacao/previa/validar',
  urlAlterarVigencia: '/vigencia_porte_anestesico/alterar',
  urlCancelarVigencia: '/vigencia_porte_anestesico/cancelar/',
  urlConsultarPortes: '/vigencia_porte_anestesico/consultar_portes',
  valorPorteUrl: '/vigencia_porte_anestesico/consultar_valor/',
  urlConsultarVigencias: '/vigencia_porte_anestesico/consultar/',
  urlDesfazerCancelamentoVigencia: '/vigencia_porte_anestesico/desfazer_cancelamento/',
  urlExcluirVigencia: '/vigencia_porte_anestesico/excluir/',
  urlIncluirVigencia: '/vigencia_porte_anestesico/incluir',
  urlValidarVigencia: '/vigencia_porte_anestesico/validar/',
  urlGerarArquivoCaixaSaude: '/relatorio_beneficiarios/arquivoCaixaSaude',
  urlGerarArquivoCaixaSaudeDep: '/relatorio_beneficiarios/arquivoCaixaSaudeDep',
  urlGerarArquivoCaixaSaudeLista: '/relatorio_beneficiarios/arquivoCaixaSaudeLista/',
  urlGerarArquivoCaixaSaudeDepLista: '/relatorio_beneficiarios/arquivoCaixaSaudeDepLista/',
  urlBeneficiarioConsultarAlteracao: '/beneficiario/cartaoCaixa/alteracao/',
  urlSalvarCartaoCaixa: '/beneficiario/salvar/cartaoCaixa/',
  urlSalvarCartaoUnimed: '/beneficiario/salvar/cartaoUnimed/',
  urlValidarArquivoCaixa: '/saude_caixa/arquivo/validar',
  urlEnviarArquivoCaixa: '/saude_caixa/arquivo/enviar',
  urlConsultarArquivosCaixaNaoPagos: '/saude_caixa/arquivo/consultar/',
  urlConsultarDetalhesArquivoCaixa: '/saude_caixa/arquivo/consultar/detalhes/',
  urlCalcularCoparticipacaoCaixa: '/saude_caixa/arquivo/calcular_copart/',
  urlExcluirArquivosCaixa: '/saude_caixa/arquivo/excluir',
  urlMovimentacaoCnu: '/movimentacao_cnu/tipo_operacao/',
  urlConsultarTiposDeTaxa: '/taxa/consultar/tipos',
  urlConsultarTaxas: '/taxa/consultar/',
  urlConsultarPrestadoresTaxa: '/taxa/consultar_prestadores/',
  urlIncluirTaxa: '/taxa/incluir',
  urlAlterarTaxa: '/taxa/alterar',
  urlExcluirTaxa: '/taxa/excluir_taxa/',
  urlExcluirTaxaPrestador: '/taxa/excluir_taxa_prestador/',
  urlExcluirTaxaItemTabela: '/taxa/excluir_taxa_item_tabela/',
  urlProcessarArquivoBenner: '/demonstrativo/arquivo_benner',
  urlConsultarArquivosBenner: '/demonstrativo/arquivo_benner_consultar/',
  urlConsultarDetalhesArquivoBenner: '/demonstrativo/arquivo_benner_detalhes/',
  urlTeste: '/vigencia_porte_anestesico/teste',  
  urlIncluirAteste: '/demonstrativo/incluir/ateste',
  urlAlterarAteste: '/demonstrativo/alterar/ateste',
  urlAssinarAteste: '/demonstrativo/assinar/ateste/',
  urlUsuariosAssinantes: '/demonstrativo/usuarios_assinantes',
  urlConsultarAssinantes: '/demonstrativo/usuarios_assinantes_ateste/',
  urlEstadoAtualDp: '/demonstrativo/estado_atual/',
  urlAssinarAtestesUsuario: '/demonstrativo/assinar/ateste_usuario/',
};

